export const batimetricTranslations = {
  en: {
    pageTitle: 'Bulletins and Notices to Mariners (NtS)',
    description: 'Check the Depth and Hydrometer Bulletin and other important information from the AIPO website',
    downloadButton: 'Download today\'s bathymetric bulletin in PDF format',
    monitoringButton: 'Open Interactive Hydrographic Monitoring on AIPo website',
    checkBulletinButton: 'Check the bathymetric bulletin on AIPo website',
    forecastBulletinButton: 'Check the Bottom Forecast Bulletin on the AIPO website',
    noticesButton: 'Check the navigation notices on AIPo website',
    appNoticesButton: 'Go to Navigation Notices in App'
  },
  it: {
    pageTitle: 'Bollettini e Avvisi ai Naviganti (NtS)',
    description: 'Consulta il Bollettino dei fondali e degli idrometri oltre ad altre importanti informazioni dal sito web AIPO',
    downloadButton: 'Scarica il bollettino batimetrico odierno in formato PDF',
    monitoringButton: 'Apri il monitoraggio idrografico Interattivo sul sito di AIPo',
    checkBulletinButton: 'Controlla il bollettino batimetrico sul sito di AIPo',
    forecastBulletinButton: 'Controlla il Bollettino di Previsione dei Fondali sul sito AIPO',
    noticesButton: 'Consulta gli avvisi di navigazione sul sito di AIPo',
    appNoticesButton: 'Vai agli Avvisi alla Navigazione in App'
  }
}; 